import { OrganizationSellersContextType } from './types'
import { createContext } from 'use-context-selector'
export const OrganizationSellersContext = createContext(
  {} as OrganizationSellersContextType
)
